import {
  global_typography_default
} from "./chunk-NYODRJJL.mjs";
import {
  global_variable_default
} from "./chunk-UCAYQZQ4.mjs";
import {
  global_config_default
} from "./chunk-L7RZOSP2.mjs";

// src/theme-provider/styles/app.tsx
import { Global } from "@emotion/react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var GlobalStyle = (theme) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Global, { styles: global_config_default }),
    /* @__PURE__ */ jsx(Global, { styles: global_variable_default(theme) }),
    /* @__PURE__ */ jsx(Global, { styles: global_typography_default })
  ] });
};
var app_default = GlobalStyle;

export {
  app_default
};
